import { GetterTree } from 'vuex'
import { IRootState, IShoppingCartState } from '@/@types'
import CONSTANTS from '@/constants'

const { PLANS, EXTENSIONS, BLACK_FRIDAY_PRODUCT_BUNDLES, TCS_PROMO_PRODUCT_BUNDLES } = CONSTANTS
const { INE_TCS_BUNDLE } = TCS_PROMO_PRODUCT_BUNDLES

const getters: GetterTree<IShoppingCartState, IRootState> = {
  selectedPlan: state => {
    const planCodesWithExceptions = Object.values(PLANS).filter(
      planId => ![PLANS.SKILL_DIVE_ANNUAL, INE_TCS_BUNDLE].includes(planId)
    )
    return (
      state.shoppingCart.find(
        item => item.merchant_id && planCodesWithExceptions.includes(item.merchant_id)
      ) || {}
    )
  },
  selectedSkillDivePlan: state => {
    const cartHasSkillDive = state.shoppingCart.find(
      item => item.merchant_id === PLANS.SKILL_DIVE_ANNUAL
    )
    return cartHasSkillDive || {}
  },
  selectedPlanCode: state => {
    const selectedPlan = state.selectedPlan as { merchant_id?: string }
    return selectedPlan.merchant_id || ''
  },
  selectedExtension: state => {
    const cartHasExtension = state.shoppingCart.find(
      item => item.merchant_id === EXTENSIONS.EXAM_EXTENSION
    )
    return cartHasExtension || {}
  },
  selectedBundle: (state, _, rootState) => {
    const fundamentalsOnCart = state.shoppingCart.find(item => item.merchant_id === PLANS.ANNUAL)
    let selectedBundle
    if (fundamentalsOnCart) {
      selectedBundle = rootState.products.availableProductBundles.find(
        item => item.slug === BLACK_FRIDAY_PRODUCT_BUNDLES.INE_BLACK_FRIDAY_BUNDLE_THREE
      )
    } else {
      selectedBundle = state.shoppingCart.find(item => item.slug)
    }
    return selectedBundle || {}
  },
  bundleProductHasError: state => {
    return state.bundleProductHasError
  },
  getShoppingCart: state => {
    return state.shoppingCart
  },
  getAddOnsCertificationsList: state => {
    return state.addOnsCertificationsList
  },
}

export default getters
